// Node
const $ = require('jquery');


$(document).ready(function () {
  initPhonesSelect();
});

function initPhonesSelect() {
  let $pageRegion = $('#page-region-id');
  let pageRegionId = $pageRegion ? $pageRegion.val() : null;

  // инициализируем селект со списком регионов, если телефоны для селекта есть
  $.ajax({
    type: 'get',
    url: `${window.website_prefix}/phones.json`,
    data: {
      page_region_id: pageRegionId
    },
    success: function(data) {
      handlePhonesLoaded(data);
    }
  });
}

function handlePhonesLoaded(regionsPhonesData) {
  // блок с телефоном в десктопной версии - если его нет, ничего не делаем
  let regionsPhonesContainer = $('#regions-phones-desktop-container');
  if (regionsPhonesContainer.length == 0) {
    return;
  }

  // инициализируем если телефоны для селекта есть
  let regionsPhones = regionsPhonesData;
  if (regionsPhones.length == 0) {
    return;
  }

  let regionLinkElement = $('#region-link');
  let regionListElement = $('#region-list');
  let phoneElement = $('#phone-number');
  let currentRegion = (regionLinkElement.text() || '').trim();
  const itemActivityClasses = 'before-ico before-ico_include-right';
  const itemActivityClassesSelector = '.before-ico.before-ico_include-right';

  // Заполняем список регионов
  regionsPhones.forEach(function (phoneData) {
    let activityClasses = '';
    if (currentRegion == phoneData.name) {
      activityClasses = itemActivityClasses;
    }
    let itemElement =
      `<li data-phone='${phoneData.phone}' 
           class='contact-city__list-item'
      >
        <a class='link_black ${activityClasses}'>
          ${phoneData.name}
        </a>
      </li>`;
    regionListElement.append(itemElement);
  });

  // Для каждого элемента списка вешаем обработчик клика
  let selectItems = $('.contact-city__list-item');
  selectItems.each(function () {
    let item = $(this);
    item.on('click', function () {
      // делаем активные элементы списка неактивными
      $(`#region-list ${itemActivityClassesSelector}`).each(function () {
        $(this).removeClass(itemActivityClasses);
      });
      let itemLinkElement = item.find('a');
      itemLinkElement.addClass(itemActivityClasses);   // выбранный элемент делаем активным
      regionListElement.fadeOut();    // гладко скрываем список
      // показываем данные выбранного элемента (регион, телефон)
      regionLinkElement.text(itemLinkElement.text());
      phoneElement.text(item.attr('data-phone'));
    });
  });

  // показываем/скрываем список при нажатии на регион
  regionLinkElement.on('click', function (e){
    e.preventDefault();
    regionListElement.fadeToggle();
  });

  $('body').on('click', function (e) {
    // клик был вне контейнера с регионами
    let clickOutside = regionsPhonesContainer.find(e.target).length == 0;
    if (clickOutside) {
      regionListElement.fadeOut();    // гладко скрываем список
    }
  });

  $(document).on('keyup', function (e) {
    if (e.code == 'Escape') {
      regionListElement.fadeOut();    // гладко скрываем список
    }
  });

  // показываем весь блок с телефоном
  regionsPhonesContainer.show();
}
